module.exports = __webpack_public_path__ + "img/V-R-3-unload-standup-shadow.b32477b2.png";